import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { Box, Divider, useTheme } from '@mui/material';

import { CohortDefinitionDSLSection } from './CohortDefinitionDSLSection';
import { CohortDefinitionDSLToUISection } from './CohortDefinitionDSLToUISection';
import { CohortDefinitionSQLSection } from './CohortDefinitionSQLSection';
import { SelectStatementType } from './enums';

export const CohortDefinitionTranslationSection = () => {
  const theme = useTheme();
  const showDefinitionTranslations = useFeatureFlag(
    'RLORShowCohortDefinitionTranslationsFS',
    SelectStatementType.NONE
  );

  // Early return if the feature flag is disabled
  if (showDefinitionTranslations === SelectStatementType.NONE) {
    return null;
  }

  return (
    <>
      <Divider
        dir="horizontal"
        sx={{ width: '100%', height: '1px', my: theme.spacing(4), color: theme.palette.grey[50] }}
      />
      <Box sx={{ width: '100%' }}>
        {[SelectStatementType.ALL, SelectStatementType.DSL].includes(
          showDefinitionTranslations
        ) && <CohortDefinitionDSLSection />}
        {[SelectStatementType.ALL, SelectStatementType.SQL].includes(
          showDefinitionTranslations
        ) && <CohortDefinitionSQLSection />}
        {[SelectStatementType.ALL, SelectStatementType.DSL].includes(
          showDefinitionTranslations
        ) && <CohortDefinitionDSLToUISection />}
      </Box>
    </>
  );
};
